// Queue Management Constants

// Import components for tabs
import QueueManagementList from '../components/his/queue-management/QueueManagementList';
import QueueReports from '../components/his/queue-management/QueueReports';
import TicketCreationTab from '../components/his/queue-management/TicketCreationTab';
import TicketManagementTab from '../components/his/queue-management/TicketManagementTab';
import NotificationSystemTab from '../components/his/queue-management/NotificationSystemTab';

export const QueueManagementColumns = [
  { field: "queueNumber", header: "Queue Number", sortable: true },
  { field: "patientName", header: "Patient Name", sortable: true },
  { field: "patientId", header: "Patient ID", sortable: true },
  { field: "department", header: "Department", sortable: true },
  { field: "priority", header: "Priority", sortable: true },
  { field: "status", header: "Status", sortable: true },
  { field: "appointmentTime", header: "Appointment Time", sortable: true },
  { field: "waitingTime", header: "Waiting Time", sortable: true },
  { field: "assignedTo", header: "Assigned To", sortable: true },
  { field: "contactNumber", header: "Contact Number", sortable: true },
  { field: "remarks", header: "Remarks", sortable: false },
  { field: "dateCreated", header: "Date Created", sortable: true },
];

// Dropdown Options
export const departmentOptions = [
  { value: "", label: "Select Department" },
  { value: "Cardiology", label: "Cardiology" },
  { value: "Emergency", label: "Emergency" },
  { value: "General Medicine", label: "General Medicine" },
  { value: "Orthopedics", label: "Orthopedics" },
  { value: "Pediatrics", label: "Pediatrics" },
  { value: "Radiology", label: "Radiology" },
  { value: "Laboratory", label: "Laboratory" },
  { value: "Pharmacy", label: "Pharmacy" },
  { value: "OPD", label: "OPD" },
  { value: "Surgery", label: "Surgery" },
];

export const priorityOptions = [
  { value: "", label: "Select Priority" },
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
  { value: "Emergency", label: "Emergency" },
];

export const statusOptions = [
  { value: "", label: "Select Status" },
  { value: "Waiting", label: "Waiting" },
  { value: "In Progress", label: "In Progress" },
  { value: "Completed", label: "Completed" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "No Show", label: "No Show" },
];

export const assignedToOptions = [
  { value: "", label: "Select Staff" },
  { value: "Dr. Ahmad Ali", label: "Dr. Ahmad Ali" },
  { value: "Dr. Sara Khan", label: "Dr. Sara Khan" },
  { value: "Dr. Hassan Ahmed", label: "Dr. Hassan Ahmed" },
  { value: "Nurse Fatima", label: "Nurse Fatima" },
  { value: "Nurse Aisha", label: "Nurse Aisha" },
  { value: "Lab Technician", label: "Lab Technician" },
  { value: "Pharmacist", label: "Pharmacist" },
];

// Dummy Data
export const dummyQueueData = [
  {
    id: 1,
    queueNumber: "Q001",
    patientName: "Ahmed Hassan",
    patientId: "PAT001",
    department: "Cardiology",
    priority: "High",
    status: "Waiting",
    appointmentTime: "10:00 AM",
    waitingTime: "15 mins",
    assignedTo: "Dr. Ahmad Ali",
    contactNumber: "+92 300 1234567",
    remarks: "Chest pain complaint",
    dateCreated: "2025-09-26"
  },
  {
    id: 2,
    queueNumber: "Q002",
    patientName: "Fatima Khan",
    patientId: "PAT002",
    department: "Emergency",
    priority: "Emergency",
    status: "In Progress",
    appointmentTime: "09:30 AM",
    waitingTime: "5 mins",
    assignedTo: "Dr. Sara Khan",
    contactNumber: "+92 301 9876543",
    remarks: "Accident case - urgent",
    dateCreated: "2025-09-26"
  },
  {
    id: 3,
    queueNumber: "Q003",
    patientName: "Ali Raza",
    patientId: "PAT003",
    department: "General Medicine",
    priority: "Medium",
    status: "Waiting",
    appointmentTime: "11:00 AM",
    waitingTime: "25 mins",
    assignedTo: "Dr. Hassan Ahmed",
    contactNumber: "+92 302 5555555",
    remarks: "Routine checkup",
    dateCreated: "2025-09-26"
  },
  {
    id: 4,
    queueNumber: "Q004",
    patientName: "Sara Ahmed",
    patientId: "PAT004",
    department: "Pediatrics",
    priority: "Low",
    status: "Completed",
    appointmentTime: "08:30 AM",
    waitingTime: "0 mins",
    assignedTo: "Dr. Ahmad Ali",
    contactNumber: "+92 303 7777777",
    remarks: "Child vaccination",
    dateCreated: "2025-09-26"
  },
  {
    id: 5,
    queueNumber: "Q005",
    patientName: "Muhammad Omar",
    patientId: "PAT005",
    department: "Laboratory",
    priority: "Medium",
    status: "Waiting",
    appointmentTime: "12:00 PM",
    waitingTime: "10 mins",
    assignedTo: "Lab Technician",
    contactNumber: "+92 304 8888888",
    remarks: "Blood test required",
    dateCreated: "2025-09-26"
  }
];

// Help Desk / Ticketing System Constants
export const helpDeskDepartments = [
  { value: "IT", label: "Information Technology" },
  { value: "HR", label: "Human Resources" },
  { value: "Finance", label: "Finance" },
  { value: "Admin", label: "Administration/Facilities" },
  { value: "Procurement", label: "Procurement" },
  { value: "SupplyChain", label: "Supply Chain" },
  { value: "Pharmacy", label: "Internal Pharmacy" },
  { value: "Medical", label: "Medical Department" },
  { value: "Nursing", label: "Nursing" },
  { value: "Laboratory", label: "Laboratory" }
];

export const ticketPriorities = [
  { value: "Low", label: "Low", color: "bg-green-500" },
  { value: "Medium", label: "Medium", color: "bg-yellow-500" },
  { value: "High", label: "High", color: "bg-orange-500" },
  { value: "Critical", label: "Critical", color: "bg-red-500" }
];

export const ticketStatuses = [
  { value: "Open", label: "Open", color: "bg-blue-500" },
  { value: "InProgress", label: "In Progress", color: "bg-purple-500" },
  { value: "OnHold", label: "On Hold", color: "bg-yellow-500" },
  { value: "Resolved", label: "Resolved", color: "bg-green-500" },
  { value: "Closed", label: "Closed", color: "bg-gray-500" }
];

// Department-Specific Fields Configuration
export const departmentFields = {
  IT: [
    { name: "systemAffected", label: "System Affected", type: "text", required: true },
    { name: "errorCodes", label: "Error Codes", type: "text", required: false },
    { name: "screenshots", label: "Screenshots", type: "file", required: false }
  ],
  HR: [
    { name: "employeeId", label: "Employee ID", type: "text", required: true },
    { name: "payPeriod", label: "Pay Period", type: "date", required: false },
    { name: "documentUpload", label: "Document Upload", type: "file", required: false }
  ],
  Finance: [
    { name: "invoiceNumber", label: "Invoice Number", type: "text", required: false },
    { name: "amount", label: "Amount", type: "number", required: false },
    { name: "paymentDate", label: "Payment Date", type: "date", required: false }
  ],
  Admin: [
    { name: "location", label: "Location", type: "text", required: true },
    { name: "urgency", label: "Urgency Level", type: "select", options: ["Normal", "Urgent", "Emergency"], required: true },
    { name: "accessRequirements", label: "Access Requirements", type: "textarea", required: false }
  ],
  Procurement: [
    { name: "vendorName", label: "Vendor Name", type: "text", required: false },
    { name: "poNumber", label: "PO Number", type: "text", required: false },
    { name: "deliveryDate", label: "Expected Delivery Date", type: "date", required: false }
  ],
  SupplyChain: [
    { name: "shipmentId", label: "Shipment ID", type: "text", required: false },
    { name: "trackingNumber", label: "Tracking Number", type: "text", required: false },
    { name: "itemDetails", label: "Item Details", type: "textarea", required: true }
  ],
  Pharmacy: [
    { name: "patientId", label: "Patient ID", type: "text", required: true },
    { name: "prescriptionDetails", label: "Prescription Details", type: "textarea", required: true },
    { name: "urgency", label: "Urgency", type: "select", options: ["Normal", "Urgent", "STAT"], required: true }
  ]
};

// Ticket Columns for Table
export const ticketColumns = [
  { field: "ticketId", header: "Ticket ID", sortable: true },
  { field: "subject", header: "Subject", sortable: true },
  { field: "department", header: "Department", sortable: true },
  { field: "priority", header: "Priority", sortable: true },
  { field: "status", header: "Status", sortable: true },
  { field: "assignee", header: "Assigned To", sortable: true },
  { field: "requester", header: "Requested By", sortable: true },
  { field: "createdDate", header: "Created Date", sortable: true },
  { field: "lastUpdated", header: "Last Updated", sortable: true },
  { field: "actions", header: "Actions", sortable: false }
];

// Dummy Tickets Data
export const dummyTickets = [
  {
    id: 1,
    ticketId: "TK-2025-001",
    subject: "Network connectivity issues in Ward 3",
    department: "IT",
    priority: "High",
    status: "Open",
    assignee: "John Smith",
    requester: "Dr. Sarah Ahmed",
    description: "Experiencing intermittent network connectivity issues affecting patient monitoring systems",
    createdDate: "2025-09-26 09:30:00",
    lastUpdated: "2025-09-26 14:15:00",
    attachments: ["network_error.jpg", "system_log.txt"],
    systemAffected: "Patient Monitoring Network",
    errorCodes: "ERR_NETWORK_TIMEOUT",
    comments: []
  },
  {
    id: 2,
    ticketId: "TK-2025-002",
    subject: "Payroll discrepancy for September",
    department: "HR",
    priority: "Medium",
    status: "InProgress",
    assignee: "Maria Garcia",
    requester: "Ahmed Hassan",
    description: "Overtime hours not reflected correctly in payroll calculation",
    createdDate: "2025-09-25 11:00:00",
    lastUpdated: "2025-09-26 16:30:00",
    attachments: [],
    employeeId: "EMP-2024-156",
    payPeriod: "2025-09-01",
    comments: [
      {
        id: 1,
        author: "Maria Garcia",
        message: "Reviewing payroll records, will update shortly.",
        timestamp: "2025-09-26 16:30:00",
        isInternal: false
      }
    ]
  },
  {
    id: 3,
    ticketId: "TK-2025-003",
    subject: "Urgent medication shortage - Insulin",
    department: "Pharmacy",
    priority: "Critical",
    status: "Open",
    assignee: "Dr. Fatima Ali",
    requester: "Pharmacy Staff",
    description: "Running low on insulin stock, need immediate procurement",
    createdDate: "2025-09-26 08:00:00",
    lastUpdated: "2025-09-26 08:00:00",
    attachments: ["stock_report.pdf"],
    patientId: "Multiple",
    prescriptionDetails: "Insulin shortage affecting diabetic patients",
    urgency: "STAT",
    comments: []
  }
];

// Queue Management Tabs Configuration
export const queueManagementTabs = t => [
//   {
//     name: t('Queue Management'),
//     content: <QueueManagementList />
//   },
  {
    name: t('Ticket Creation'),
    content: <TicketCreationTab />
  },
  {
    name: t('Ticket Management'),
    content: <TicketManagementTab />
  },
  {
    name: t('Notification System'),
    content: <NotificationSystemTab />
  },
//   {
//     name: t('Reports & Analytics'),
//     content: <QueueReports />
//   }
];